import { Query } from '../../_base/actionBus/Query';
import { PublicAnnouncement } from '../../models/publicAnnouncements/PublicAnnouncement';

export class GetPublicAnnouncement extends Query<PublicAnnouncement> {
    constructor(public token: string) { super(); }
}
